export default {
  isEnabled: state => flag => {
    if (state && flag && state[flag] && 'isEnabled' in state[flag]) {
      return state[flag].isEnabled();
    }
  },
  getValue: state => flag => {
    if (state && flag && state[flag] && 'getValue' in state[flag]) {
      return state[flag].getValue();
    }
  },
};
